import React, {Component} from 'react';
import {Tooltip} from "antd";
import interviewIcon from "./interviewIcon.png";

class InterviewNormalTitle extends Component {
    static defaultProps = {
        width:"550px",
        dataIndex: "title"
    };
    render() {
        let {record,width,dataIndex} = this.props;
        let data = "";
        try {
            eval(`data = record.${dataIndex}`);
        }catch (e) {
        }
        let title = data;
        if(data && data.length > 30){
            title = (data).substring(0, 30) + "..."
        }
        return  <div style={{width:width,overflow: "hidden",textOverflow: "ellipsis",whiteSpace:"nowrap"}}>
            <div title={record.title}>
                {record.taskId && <img style={{marginRight:7}} width={20} src={interviewIcon}/>}{title}
            </div>
        </div>
    }
}

export default InterviewNormalTitle;
